import { render, staticRenderFns } from "./PointsTablePage.vue?vue&type=template&id=4360b87b&scoped=true"
import script from "./PointsTablePage.vue?vue&type=script&lang=js"
export * from "./PointsTablePage.vue?vue&type=script&lang=js"
import style0 from "./PointsTablePage.vue?vue&type=style&index=0&id=4360b87b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4360b87b",
  null
  
)

export default component.exports